/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import Graphql from '@/services/Graphql'

function calcBaseUrl (fullPath) {
  let urlSlitted = fullPath.split('/').slice(0, 4).join('/') + '/'
  return urlSlitted
}

export default {
  load (ctx, { fullPath }) {
    const baseUrl = calcBaseUrl(fullPath)
    if (process.client) {
      if (ctx.state.config.baseUrl && ctx.state.config.baseUrl === baseUrl) {
        return ctx.state.config
      }
    }
    // cached call
    return Graphql.genericCallCash({
      storeViewCode: '',
      variables: {
        value: baseUrl
      },
      graphSchemaType: 'storeConfig'
    })
      .then(res => {
        if (res.data && res.data.storeConfig) {
          const storeConfig = res.data.storeConfig
          storeConfig.baseUrl = baseUrl
          ctx.commit('setConfig', storeConfig)
          ctx.commit('ui/setLocale', { storeViewCode: storeConfig.code, locale: ctx.state.config.locale, rootState: ctx.rootState }, { root: true })
          return storeConfig
        }
      })
  }
}
